<template>
<v-dialog v-model="dialog" persistent max-width="860px">
    <v-card>
        <v-card-title class="headline">{{ $t('reservations.modal.invoice_title') }}</v-card-title>
        <v-card-text :class="{'px-1':$vuetify.breakpoint.smAndDown}">
            <v-row no-gutters>
                <v-col class="py-0" sm="6" cols="12">
                    <div class="py-1" v-if="item.invoicing_details.invoice_value && item.invoicing_details.invoice_value > 0">
                        <div class="regular font-weight-medium">{{ $t('reservations.modal.issue_invoice_hotel') }}</div>
                        <div class="important" v-if="item.invoicing_details&&item.invoicing_details.customer ">{{ item.invoicing_details.customer.name }}</div>
                        <div class="regular" v-if="item.invoicing_details&&item.invoicing_details.customer">{{ item.invoicing_details.customer.fiscal_code }}</div>
                        <div class="regular" v-if="item.invoicing_details&&item.invoicing_details.customer">{{ item.invoicing_details.customer.registry_number }}</div>
                        <div class="regular" v-if="item.invoicing_details&&item.invoicing_details.customer">{{ item.invoicing_details.customer.address.street }}, {{ item.invoicing_details.customer.address.region }}</div>
                        <div class="regular" v-if="item.invoicing_details&&item.invoicing_details.customer">{{ item.invoicing_details.customer.email }}</div>
                        <div class="regular" v-if="item.invoicing_details&&item.invoicing_details.customer">{{ item.invoicing_details.customer.banks[0].name }}</div>
                        <div class="regular" v-if="item.invoicing_details&&item.invoicing_details.customer">{{ item.invoicing_details.customer.banks[0].account }}</div>
                    </div>
                </v-col>
                <v-col class="py-0" sm="6" cols="12">
                    <div v-if="item.invoicing_details.invoice_value && item.invoicing_details.invoice_value > 0">
                        <v-row class="pt-2" no-gutters>
                            <v-col class="py-0" md="9" cols="8">{{ $t('reservations.modal.values.total_booking') }}</v-col>
                            <v-col class="py-0" md="3" cols="4">
                                <div class="text-end">
                                    <im-price :price="item.invoicing_details.booking_value" :currency="item.invoicing_details.currency" />
                                </div>
                            </v-col>
                            <v-col class="py-0" md="9" cols="8">{{ $t('reservations.modal.commission_percent') }}</v-col>
                            <v-col class="py-0" md="3" cols="4">
                                <div class="font-weight-bold text-end">
                                    {{ item.invoicing_details.commission_percentage}} %
                                </div>
                            </v-col>
                            <v-col class="py-0" md="9" cols="8">{{ $t('reservations.modal.values.commission') }}</v-col>
                            <v-col class="py-0" md="3" cols="4">
                                <div class="text-end">
                                    <im-price :price="item.invoicing_details.commission_value" :currency="item.invoicing_details.currency" />
                                </div>
                            </v-col>
                            <v-col class="py-0" md="9" cols="8">{{ $t('reservations.modal.values.invoice') }}</v-col>
                            <v-col class="py-0" md="3" cols="4">
                                <div class="text-end">
                                    <im-price :price="item.invoicing_details.invoice_value" :currency="item.invoicing_details.currency" />
                                </div>
                            </v-col>
                        </v-row>
                        <div class="blue pa-2 white--text my-1 d-flex justify-center align-center">
                            <v-icon color="white" class="px-2">info</v-icon>
                            <span>{{ $t('reservations.modal.message_invoice_no_issue') }}</span>
                        </div>
                    </div>
                    <div v-else>
                        <v-row class="pt-2" no-gutters>
                            <v-col class="py-0" md="9" cols="8">{{ $t('reservations.modal.values.invoice') }}</v-col>
                            <v-col class="py-0" md="3" cols="4">
                                <div class="text-end">
                                    <im-price :price="item.commissioning_details.hotel.commissionable_value" :currency="item.commissioning_details.hotel.currency" />
                                </div>
                            </v-col>
                        </v-row>
                        <div class="blue pa-2 white--text my-1 d-flex justify-center align-center">
                            <v-icon color="white" class="px-2 ">info</v-icon>
                            <span>{{ $t('reservations.modal.message_invoice_issue') }}</span>
                        </div>
                        <v-row no-gutters>
                            <v-col class="py-0" md="9" cols="8">{{ $t('reservations.modal.commission_percent') }}</v-col>
                            <v-col class="py-0" md="3" cols="4">
                                <div class="font-weight-bold text-end">
                                    {{ item.commissioning_details.hotel.commission_percentage}} %
                                </div>
                            </v-col>
                            <v-col class="py-0" md="9" cols="8">{{ $t('reservations.modal.values.commission') }}</v-col>
                            <v-col class="py-0" md="3" cols="4">
                                <div class="text-end">
                                    <im-price :price="item.commissioning_details.hotel.commission_value" :currency="item.commissioning_details.hotel.currency" />
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="emitExit">{{ $t('button.exit') }}</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>


<script>
import defaults from "../../utils/PropDefaults.js";
import IMPrice from '../../small-components/IMPrice.vue';

export default {
    components: {
        'im-price': IMPrice,
    },

    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: function () {
                return defaults.reservation_item
            }

        },
    },

    data: () => {
        return {}
    },
    methods: {
        emitExit() {
            this.$emit('close');
        }
    }
}
</script>
